import { Flex, Pill, Text } from '@fullstory/components';
import React, { PropsWithChildren } from 'react';
import { SegmentDot } from '../SegmentDot';

const DimensionPill: React.FC<PropsWithChildren<unknown>> = ({ children }) => (
  <Pill data-component="DimensionPill" variant="primary" noExternalSpacing>
    <Text appearance="bodySmall" color="default" noWrap tag="div">
      {children}
    </Text>
  </Pill>
);

interface Item {
  color: React.ComponentProps<typeof SegmentDot>['color'];
  label: string;
  pill: boolean;
  isPreviousData: boolean;
}

export interface VisualizationLegendPrintProps {
  items: Item[];
  className?: string;
}

export const VisualizationLegendPrint: React.FC<VisualizationLegendPrintProps> = ({
  items,
  className,
}) => (
  <Flex
    data-component="VisualizationLegendPrint"
    justifyContent="center"
    alignItems="center"
    flexWrap="wrap"
    gap={32}
    className={className}
  >
    {items.map(({ color, pill, isPreviousData, label }) => {
      const key = `${color}-${pill}-${isPreviousData}-${label}`;
      const content = (
        <Flex justifyContent="flex-start">
          <SegmentDot color={color} variant={isPreviousData ? 'secondary' : 'primary'} />
          <Text appearance="bodySmall" style={{ wordBreak: 'break-all' }}>
            {label}
          </Text>
        </Flex>
      );

      if (pill) {
        return <DimensionPill key={key}>{content}</DimensionPill>;
      }

      return <React.Fragment key={key}>{content}</React.Fragment>;
    })}
  </Flex>
);
